/* Memorial – mejoras 26-sep-2026
   1) La burbuja de WhatsApp (widget HighLevel) no tapa "Finalizar compra":
      - se oculta mientras el carrito lateral o un menú está abierto (CSS en custom-code-body)
      - en celular y en /cart se oculta el mensaje emergente "Haz tu pedido ahora por WhatsApp"
        (el botón redondo de WhatsApp sigue visible)
   2) Costo de envío visible antes del pago (bajo el precio y en el carrito).
*/
(function () {
  'use strict';

  /* ---------- 1. Mensaje emergente de WhatsApp ---------- */
  var PROMPT_CSS = '.lc_text-widget--prompt{display:none!important}';
  function hidePrompt() {
    var w = document.querySelector('chat-widget');
    if (!w || !w.shadowRoot) return false;
    if (w.shadowRoot.getElementById('mm-hide-prompt')) return true;
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var isCart = document.body.classList.contains('template-cart');
    if (!isMobile && !isCart) return true;
    var s = document.createElement('style');
    s.id = 'mm-hide-prompt';
    s.textContent = PROMPT_CSS;
    w.shadowRoot.appendChild(s);
    return true;
  }
  var tries = 0;
  var timer = setInterval(function () {
    if (hidePrompt() || ++tries > 60) clearInterval(timer);
  }, 500);

  /* ---------- 2. Aviso de costo de envío ---------- */
  var tpl = document.getElementById('mm-envio-tpl');
  function makeNote() {
    return tpl ? tpl.content.firstElementChild.cloneNode(true) : null;
  }

  function placeProduct() {
    if (!document.body.classList.contains('template-product')) return;
    var price = document.querySelector('.main-product__block-price .product-block-group--price');
    if (!price || price.parentNode.querySelector('.mm-envio')) return;
    var n = makeNote();
    if (n) price.insertAdjacentElement('afterend', n);
  }

  function placeCart() {
    var boxes = document.querySelectorAll('.m-cart-drawer__summary, .m-cart__summary');
    boxes.forEach(function (box) {
      if (box.querySelector('.mm-envio')) return;
      var sub = box.querySelector('[data-cart-subtotal]');
      var n = makeNote();
      if (!n) return;
      if (sub) sub.insertAdjacentElement('afterend', n);
      else box.appendChild(n);
      var old = box.querySelector('.m-cart__shipping-note');
      if (old) old.style.display = 'none';
    });
  }

  function run() { placeProduct(); placeCart(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // El carrito lateral se vuelve a dibujar al agregar productos: revisar de nuevo.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; placeCart(); });
  }).observe(document.body, { childList: true, subtree: true });
})();

/* ---------- 3. Ficha de producto en celular (mejoras 1 y 2) ----------
   1) Primera pantalla: foto más baja, sin miniaturas ni SKU, aviso de cuándo llega.
   2) Día, horario y tarjeta vienen preseleccionados; resumen visible con "Cambiar".
      "De parte de" sigue siendo obligatorio.
*/
(function () {
  'use strict';
  if (!document.body.classList.contains('template-product')) return;

  function limaISO(n) {
    var p = {};
    new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Lima', year: 'numeric', month: '2-digit', day: '2-digit' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var d = new Date(Date.UTC(+p.year, +p.month - 1, +p.day + (n || 0), 12));
    return d.toISOString().slice(0, 10);
  }
  var DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'set', 'oct', 'nov', 'dic'];
  function etiquetaISO(iso) {
    var d = new Date(iso + 'T12:00:00Z');
    return DIAS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MESES[d.getUTCMonth()];
  }
  function limpio(t) { return (t || '').replace(/\s+/g, ' ').trim(); }

  /* 3a. Contador de fotos (reemplaza las miniaturas en celular) */
  function contadorFotos() {
    var cont = document.querySelector('.m-product-media--mobile .m-product-media--slider__images');
    if (!cont || cont.querySelector('.mm-fotos')) return;
    var n = cont.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
    if (n < 2) return;
    var b = document.createElement('div');
    b.className = 'mm-fotos';
    b.textContent = n + ' fotos · desliza ›';
    cont.appendChild(b);
  }

  /* 3b. Aviso "Llega hoy..." bajo el precio */
  function avisoEntrega() {
    var btns = document.querySelectorAll('.mm-dia__btn');
    var precio = document.querySelector('.main-product__block-price .product-block-group--price');
    if (btns.length < 2 || !precio) return false;
    var el = document.querySelector('.mm-llega');
    if (!el) {
      el = document.createElement('div');
      el.className = 'mm-llega';
      precio.insertAdjacentElement('afterend', el);
    }
    var txt;
    if (!btns[0].disabled) {
      var nota = document.querySelector('.mm-dia__nota');
      var m = nota && /hasta las (.+)$/.exec(limpio(nota.textContent));
      txt = 'Llega hoy si pides antes de las ' + (m ? m[1] : '5:30 p. m.');
    } else if (!btns[1].disabled) {
      txt = 'Entrega desde mañana ' + limpio(btns[1].querySelector('span') && btns[1].querySelector('span').textContent);
    } else {
      var prox = document.querySelector('.mm-dia__prox');
      txt = prox ? 'Próxima entrega: ' + limpio(prox.textContent) : 'Elige la fecha de entrega abajo';
    }
    el.textContent = txt;
    return true;
  }

  /* 3c. Preselección de día, horario y tarjeta */
  var fecha, fp, sel;
  function preseleccionar() {
    fecha = document.querySelector('input[name="properties[Fecha]"]');
    fp = fecha && fecha._flatpickr;
    var btns = document.querySelectorAll('.mm-dia__btn');
    if (!fecha) return true;              // producto sin fecha: nada que hacer
    if (!fp || btns.length < 2) return false;
    sel = document.querySelector('select[name="properties[Horario]"]');

    if (!fecha.value) {
      var iso = null;
      if (!btns[0].disabled) iso = limaISO(0);
      else if (!btns[1].disabled) iso = limaISO(1);
      if (iso) fp.setDate(iso, true);
    }
    setTimeout(function () {
      if (sel && !sel.value) {
        var op = Array.prototype.filter.call(sel.options, function (o) { return o.value && !o.disabled; })[0];
        if (op) { sel.value = op.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      var radios = document.querySelectorAll('.dedicatoria-item input[type="radio"]');
      var marcado = Array.prototype.some.call(radios, function (r) { return r.checked; });
      if (radios.length && !marcado) {
        radios[0].checked = true;
        radios[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
      resumen();
    }, 450);
    return true;
  }

  /* 3d. Resumen visible sobre el botón, con "Cambiar" */
  function resumen() {
    var form = document.querySelector('.main-product__block-buy_buttons product-form');
    if (!form) return;
    var box = document.querySelector('.mm-resumen');
    if (!box) {
      box = document.createElement('div');
      box.className = 'mm-resumen';
      form.insertAdjacentElement('beforebegin', box);
      box.addEventListener('click', function (e) {
        var a = e.target.closest('[data-mm-cambiar]');
        if (!a) return;
        e.preventDefault();
        var dest = document.querySelector('.fecha-horario-container') || document.querySelector('.custom-container');
        if (dest) dest.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    var partes = [];
    if (fecha && fecha.value) {
      var dia = fecha.value === limaISO(0) ? 'Hoy, ' : (fecha.value === limaISO(1) ? 'Mañana, ' : '');
      partes.push('<b>' + dia + etiquetaISO(fecha.value) + '</b>');
    }
    if (sel && sel.value) partes.push('<b>' + limpio(sel.value) + '</b>');
    var r = document.querySelector('.dedicatoria-item input[type="radio"]:checked');
    var tarjeta = r ? 'Tarjeta: ' + limpio(r.value) : '';
    if (!partes.length) { box.hidden = true; return; }
    box.hidden = false;
    box.innerHTML = '<div class="mm-resumen__txt">Entrega: ' + partes.join(' · ') +
      (tarjeta ? '<br><span>' + tarjeta + '</span>' : '') +
      '</div><a href="#" class="mm-resumen__cambiar" data-mm-cambiar>Cambiar</a>';
  }

  /* 3e. Si falta "De parte de", la barra fija lleva a ese campo */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.mm-sticky-bar__btn');
    if (!b) return;
    var dp = document.getElementById('de-parte-de');
    var base = document.querySelector('select[name="properties[Base]"]');
    var atc = document.getElementById('add-to-cart-btn');
    var falta = (base && !base.value) ? base : ((dp && !limpio(dp.value)) ? dp : null);
    if (falta && atc && !atc.disabled) {
      e.stopPropagation();
      e.preventDefault();
      var destino = (falta.classList.contains('mm-oculto') && falta.nextElementSibling) ? falta.nextElementSibling : falta;
      destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () {
        destino.classList.add('mm-falta');
        var foco = destino.matches('input,select,textarea') ? destino : destino.querySelector('button:not([disabled])');
        if (foco) foco.focus({ preventScroll: true });
      }, 350);
    }
  }, true);
  function quitarFalta(e) {
    var el = e.target;
    if (el && el.classList && el.classList.contains('mm-falta') && limpio(el.value)) el.classList.remove('mm-falta');
  }
  document.addEventListener('input', quitarFalta);
  document.addEventListener('change', quitarFalta);

  function enlazar() {
    if (fecha) fecha.addEventListener('change', function () { setTimeout(function () { resumen(); avisoEntrega(); }, 50); });
    if (sel) sel.addEventListener('change', resumen);
    document.querySelectorAll('.dedicatoria-item input[type="radio"]').forEach(function (r) { r.addEventListener('change', resumen); });
  }

  var n = 0;
  var t = setInterval(function () {
    contadorFotos();
    if (preseleccionar() || ++n > 40) {
      clearInterval(t);
      avisoEntrega();
      enlazar();
    }
  }, 250);
})();

/* ---------- 4. Horario y Tipo de base como botones + orden fijo de tarjetas (27-sep-2026) ----------
   Los botones son solo la parte visible: la lista original sigue debajo (oculta) y es la que
   viaja con el pedido, así que las validaciones y las propiedades del pedido no cambian.
*/
(function () {
  'use strict';
  if (!document.body.classList.contains('template-product')) return;

  var ORDEN_TARJETAS = ['hojas de olivo', 'marco clasico gris', 'cruz y flores', 'flores moradas', 'flores amarillas y azules'];
  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  /* 4a. Tarjetas siempre en el mismo orden (las que no estén en la lista van al final) */
  function ordenarTarjetas() {
    var ul = document.querySelector('.dedicatorias-list');
    if (!ul || ul.getAttribute('data-mm-orden')) return;
    var items = Array.prototype.slice.call(ul.children).map(function (li, k) {
      var r = li.querySelector('input[type="radio"]');
      var i = ORDEN_TARJETAS.indexOf(norm(r && r.value));
      return { li: li, k: k, i: i < 0 ? 99 : i };
    });
    items.sort(function (a, b) { return (a.i - b.i) || (a.k - b.k); });
    items.forEach(function (o) { ul.appendChild(o.li); });
    ul.setAttribute('data-mm-orden', '1');
  }

  /* 4b. Convierte una lista desplegable en botones */
  function etiquetaHorario(t) {
    return t.replace(/\s*·.*$/, '').replace(/^\s*de\s+/i, '')
      .replace(/(\d{1,2})\s*(am|pm)/gi, '$1 $2').replace(/\s+a\s+/i, ' – ').trim();
  }
  function aBotones(sel, extraClase, etiqueta) {
    if (!sel || sel.getAttribute('data-mm-btns')) return;
    sel.setAttribute('data-mm-btns', '1');
    var cont = document.createElement('div');
    cont.className = 'mm-opciones ' + extraClase;
    cont.setAttribute('role', 'group');
    sel.insertAdjacentElement('afterend', cont);
    sel.classList.add('mm-oculto');
    sel.setAttribute('tabindex', '-1');
    sel.setAttribute('aria-hidden', 'true');

    function pintar() {
      var html = '';
      Array.prototype.forEach.call(sel.options, function (o, idx) {
        if (!o.value) return;
        var txt = o.getAttribute('data-txt') || o.textContent;
        html += '<button type="button" class="mm-op" data-i="' + idx + '"' +
          (o.disabled ? ' disabled' : '') +
          ' aria-pressed="' + (sel.value === o.value && !o.disabled ? 'true' : 'false') + '">' +
          '<b>' + esc(etiqueta(txt)) + '</b>' +
          (o.disabled ? '<span>No disponible hoy</span>' : '') + '</button>';
      });
      if (cont.innerHTML !== html) cont.innerHTML = html;
    }
    cont.addEventListener('click', function (e) {
      var b = e.target.closest('.mm-op');
      if (!b || b.disabled) return;
      var o = sel.options[+b.getAttribute('data-i')];
      if (!o || o.disabled) return;
      sel.value = o.value;
      sel.dispatchEvent(new Event('input', { bubbles: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      sel.classList.remove('mm-falta', 'mm-campo-falta');
      cont.classList.remove('mm-falta');
    });
    sel.addEventListener('change', pintar);
    new MutationObserver(pintar).observe(sel, { subtree: true, childList: true, attributes: true, characterData: true });
    pintar();
    // Si otro script cambia el valor sin avisar, se corrige al volver a mirar
    setInterval(pintar, 1500);
  }

  ordenarTarjetas();
  var tries = 0;
  var t = setInterval(function () {
    ordenarTarjetas();
    var hor = document.querySelector('select[name="properties[Horario]"]');
    var base = document.querySelector('select[name="properties[Base]"]');
    aBotones(hor, 'mm-opciones--horario', etiquetaHorario);
    aBotones(base, 'mm-opciones--base', function (x) { return x.trim(); });
    if ((hor || !document.querySelector('.fecha-horario-container')) || ++tries > 40) clearInterval(t);
  }, 200);
})();
